import { render, staticRenderFns } from "./home-admin.vue?vue&type=template&id=496c909b"
import script from "./home-admin.vue?vue&type=script&lang=js"
export * from "./home-admin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports